import { Outlet } from "react-router";

import { ItemMoveDndProvider } from "@/modules/mine";
import { OnboardingCelebration } from "@/modules/onboarding/onboarding-celebration";
import {
  AppSidebar,
  ResizableSidebarProvider,
} from "@/widgets/app-sidebar";
import WorkspaceShell from "@/widgets/workspace-shell";

const MinePage = () => {
  return (
    <ResizableSidebarProvider className="h-svh overflow-hidden">
      <ItemMoveDndProvider>
        <AppSidebar />
        <WorkspaceShell>
          <Outlet />
        </WorkspaceShell>
        <OnboardingCelebration />
      </ItemMoveDndProvider>
    </ResizableSidebarProvider>
  );
};

export default MinePage;
